(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunavi-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lunavi-hero')) {
    customElements.define(
      'lunavi-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.lv-hero__slide'));
          this.dots = Array.from(this.querySelectorAll('.lv-hero__dot'));
          this.index = 0;
          if (this.slides.length < 2) return;
          this.dots.forEach((dot, i) =>
            dot.addEventListener('click', () => {
              this.go(i);
              this.start();
            })
          );
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) {
              this.go(i);
              this.stop();
            }
          });
          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        go(i) {
          this.index = (i + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, n) => {
            const active = n === this.index;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('inert', !active);
          });
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
        }

        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) * 1000);
        }

        stop() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunavi-product"]) return;
  try {
    
  if (!customElements.get('lunavi-product')) {
    customElements.define(
      'lunavi-product',
      class extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
          this.form = this.querySelector('form');
          this.idInput = this.querySelector('input[type=hidden][name=id]');
          this.slides = Array.from(this.querySelectorAll('.lv-pdp__slide'));
          this.thumbs = Array.from(this.querySelectorAll('.lv-pdp__thumb'));
          this.index = Math.max(
            0,
            this.slides.findIndex((slide) => slide.classList.contains('is-active'))
          );

          this.addEventListener('change', (event) => {
            const input = event.target;
            if (input.matches('[data-variant-radio]')) {
              this.setVariant(this.variants.find((variant) => String(variant.id) === input.value));
            } else if (input.matches('[data-option-radio]')) {
              const chosen = Array.from(this.querySelectorAll('[data-option-radio]:checked')).map((el) => el.value);
              this.setVariant(this.variants.find((variant) => variant.options.every((value, i) => value === chosen[i])));
            } else if (input.matches('[data-pack-radio]')) {
              this.setPrices(input.dataset.price, input.dataset.compare);
            }
          });

          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('.lv-pdp__thumb');
            const arrow = event.target.closest('[data-dir]');
            if (thumb) this.go(this.thumbs.indexOf(thumb));
            if (arrow) this.go(this.index + Number(arrow.dataset.dir));
            if (event.target.closest('[data-sticky-add]') && this.form) {
              if (this.form.requestSubmit) this.form.requestSubmit();
              else this.form.submit();
            }
          });

          const sticky = this.querySelector('[data-sticky]');
          const submit = this.querySelector('[data-submit]');
          if (sticky && submit && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              const entry = entries[0];
              sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
            });
            this.observer.observe(submit);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        setPrices(price, compare) {
          this.querySelectorAll('[data-price]').forEach((el) => {
            if (!el.matches('input')) el.textContent = price;
          });
          this.querySelectorAll('[data-compare]').forEach((el) => {
            if (el.matches('input')) return;
            el.textContent = compare || '';
            el.hidden = !compare;
          });
        }

        setVariant(variant) {
          const buttons = this.querySelectorAll('[data-submit], [data-sticky-add]');
          const submit = this.querySelector('[data-submit]');
          const label = this.querySelector('[data-submit-label]');

          if (!variant) {
            buttons.forEach((button) => (button.disabled = true));
            if (submit && label) label.textContent = submit.dataset.soldout;
            return;
          }

          if (this.idInput) this.idInput.value = variant.id;
          this.setPrices(variant.price, variant.compare);
          buttons.forEach((button) => (button.disabled = !variant.available));
          if (submit && label) label.textContent = variant.available ? submit.dataset.label : submit.dataset.soldout;

          if (variant.media) {
            const i = this.slides.findIndex((slide) => slide.dataset.mediaId === String(variant.media));
            if (i > -1) this.go(i);
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        go(i) {
          const total = this.slides.length;
          if (!total) return;
          this.index = (i + total) % total;
          this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === this.index));
          this.thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunavi-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lunavi-stories')) {
    customElements.define(
      'lunavi-stories',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.lv-stories__track');
          this.prev = this.querySelector('.lv-stories__arrow--prev');
          this.next = this.querySelector('.lv-stories__arrow--next');
          if (!this.track) return;

          this.addEventListener('click', (event) => {
            const arrow = event.target.closest('.lv-stories__arrow');
            if (!arrow) return;
            const card = this.track.querySelector('.lv-story');
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
          });

          this.update = () => {
            if (!this.prev || !this.next) return;
            const max = this.track.scrollWidth - this.track.clientWidth - 2;
            this.prev.disabled = this.track.scrollLeft <= 2;
            this.next.disabled = this.track.scrollLeft >= max;
          };
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          if (this.update) window.removeEventListener('resize', this.update);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
